import React, { useState } from "react";
import {
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
} from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

const FilterDescription = ({
  onFilterChange,
  bearingCapacityValues,
  measurementUnit,
}) => {
  const [showMoreGearwheel, setShowMoreGearwheel] = useState(false);
  const [showMoreValve, setShowMoreValve] = useState(false);
  const [showMoreBearing, setShowMoreBearing] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "flex-start",
        rowGap: 4,
        columnGap: 4,
        px: 2,
        py: 3,
        maxWidth: "1470px", // ✅ Set a practical max width
        margin: "0 auto", // ✅ Center it horizontally
        fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
      }}
    >
      {/* Gearwheel Set Filter */}
      <Box sx={{ flex: "1 1 300px", minWidth: "280px" }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", mb: 1, fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif` }}
        >
          Gearwheel set
        </Typography>

        <FormControl fullWidth>
          <InputLabel
            id="gearwheel-set-label"
            sx={{ display: "none", fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif` }}
          >
            Select gearwheel set type
          </InputLabel>
          <Select
            labelId="gearwheel-set-label"
            defaultValue=""
            onChange={(e) => onFilterChange("gearwheelSet", e.target.value)}
            displayEmpty
            renderValue={(selected) =>
              selected !== "" ? (
                selected === "Geroler" ? (
                  "Geroler"
                ) : (
                  selected
                )
              ) : (
                <span style={{ color: "#888", fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif` }}>
                  Select gear wheel set type
                </span>
              )
            }
            IconComponent={KeyboardArrowDownOutlinedIcon}
            sx={{
              borderRadius: 0,
              height: 40,
              boxShadow: "none",
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: 0,
                borderColor: "#ccc",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#ccc",
                boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.03)",
                // ⬅️ darker shadow
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#888",
              },
            }}
          >
            <MenuItem
              value=""
              sx={{
                fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                "&.Mui-selected": {
                  backgroundColor: "white !important",
                  color: "black", // optional → makes text visible
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#767676 !important",
                  color: "#fff", // optional → makes text visible
                },
                "&:hover": {
                  backgroundColor: "#767676", // a lighter hover shade
                  color: "#fff", // optional → makes text visible
                },
              }}
            >
              All
            </MenuItem>
            <MenuItem
              value="Gerotor"
              sx={{
                fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                "&.Mui-selected": {
                  backgroundColor: "white !important",
                  color: "black", // optional → makes text visible
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#767676 !important",
                  color: "#fff", // optional → makes text visible
                },
                "&:hover": {
                  backgroundColor: "#767676", // a lighter hover shade
                  color: "#fff", // optional → makes text visible
                },
              }}
            >
              Gerotor
            </MenuItem>
            <MenuItem
              value="Geroler"
              sx={{
                fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                "&.Mui-selected": {
                  backgroundColor: "white !important",
                  color: "black", // optional → makes text visible
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#767676 !important",
                  color: "#fff", // optional → makes text visible
                },
                "&:hover": {
                  backgroundColor: "#767676", // a lighter hover shade
                  color: "#fff", // optional → makes text visible
                },
              }}
            >
              Geroler
            </MenuItem>
          </Select>

          <Typography
            variant="body2"
            sx={{
              mt: 1,
              color: "#666",
              lineHeight: 1.43,
              fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
            }}
          >
            The choice between Gerotor and Geroler gearwheel set types has an
            impact on the efficiency, durability, and overall performance of a
            hydraulic motor. Understanding the distinctions between these two
            technologies is essential for selecting the optimal solution for
            your application.
            {!showMoreGearwheel && (
              <span
                onClick={() => setShowMoreGearwheel(true)}
                style={{
                  cursor: "pointer",
                  color: "#ac070c",
                  textDecoration: "underline",
                  marginLeft: "4px",
                  fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                }}
              >
                ...more
              </span>
            )}
          </Typography>

          {showMoreGearwheel && (
            <>
              <Box
                mt={1}
                sx={{
                  color: "#666",
                  fontSize: "0.875rem",
                  fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                }}
              >
                <Box mt={1}>
                  <strong>Gerotor :</strong> Gerotor motors offer an economical
                  solution for low-to-medium duty cycles.
                </Box>
                <Box mt={1}>
                  <strong>Geroler :</strong> Geroler motors deliver high
                  efficiency and long operational life under medium-to-high-duty
                  cycles and are also recommended for applications with thin oil
                  and frequent reverse operations.
                  <span
                    onClick={() => setShowMoreGearwheel(false)}
                    style={{
                      cursor: "pointer",
                      color: "#ac070c",
                      textDecoration: "underline",
                      marginLeft: "4px",
                      fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                    }}
                  >
                    ...less
                  </span>
                </Box>
              </Box>
            </>
          )}
        </FormControl>
      </Box>

      {/* Valve System Filter */}
      <Box sx={{ flex: "1 1 300px", minWidth: "280px" }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", mb: 1, fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif` }}
        >
          Valve system
        </Typography>

        <FormControl fullWidth>
          <InputLabel
            id="valve-system-label"
            sx={{ display: "none", fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif` }}
          >
            Select valve type
          </InputLabel>
          <Select
            labelId="valve-system-label"
            defaultValue=""
            onChange={(e) => onFilterChange("valveSystem", e.target.value)}
            displayEmpty
            renderValue={(selected) =>
              selected !== "" ? (
                selected
              ) : (
                <span style={{ color: "#888", fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif` }}>
                  Select valve type
                </span>
              )
            }
            IconComponent={KeyboardArrowDownOutlinedIcon}
            sx={{
              borderRadius: 0,
              height: 40,
              boxShadow: "none",
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: 0,
                borderColor: "#ccc",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#ccc",
                boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.03)",
                // ⬅️ darker shadow
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#888",
              },
            }}
          >
            <MenuItem
              value=""
              sx={{
                fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                "&.Mui-selected": {
                  backgroundColor: "white !important",
                  color: "black", // optional → makes text visible
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#767676 !important",
                  color: "#fff", // optional → makes text visible
                },
                "&:hover": {
                  backgroundColor: "#767676", // a lighter hover shade
                  color: "#fff", // optional → makes text visible
                },
              }}
            >
              All
            </MenuItem>
            <MenuItem
              value="Spool Valve"
              sx={{
                fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                "&.Mui-selected": {
                  backgroundColor: "white !important",
                  color: "black", // optional → makes text visible
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#767676 !important",
                  color: "#fff", // optional → makes text visible
                },
                "&:hover": {
                  backgroundColor: "#767676", // a lighter hover shade
                  color: "#fff", // optional → makes text visible
                },
              }}
            >
              Spool valve
            </MenuItem>
            <MenuItem
              value="Disc Valve"
              sx={{
                fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                "&.Mui-selected": {
                  backgroundColor: "white !important",
                  color: "black", // optional → makes text visible
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#767676 !important",
                  color: "#fff", // optional → makes text visible
                },
                "&:hover": {
                  backgroundColor: "#767676", // a lighter hover shade
                  color: "#fff", // optional → makes text visible
                },
              }}
            >
              Disc valve
            </MenuItem>
          </Select>

          <Typography
            variant="body2"
            sx={{
              mt: 1,
              color: "#666",
              lineHeight: 1.43,
              fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
            }}
          >
            The valve system (distributor valve) drives synchronously by the
            internal gear through a cardan shaft, ensuring that the individual
            chambers of the motor are filled and emptied precisely - without
            losses. There are two forms of valve systems:
            {!showMoreValve && (
              <span
                onClick={() => setShowMoreValve(true)}
                style={{
                  cursor: "pointer",
                  color: "#ac070c",
                  textDecoration: "underline",
                  marginLeft: "4px",
                  fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                }}
              >
                ...more
              </span>
            )}
          </Typography>

          {showMoreValve && (
            <Box
              mt={1}
              sx={{
                color: "#666",
                fontSize: "0.875rem",
                fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
              }}
            >
              <Box mt={1}>
                <strong>Spool valve: </strong> Spool valve motors are
                characterized by a compact and robust design and deliver optimal
                value through a balanced cost-performance ratio.
              </Box>
              <Box mt={1}>
                <strong>Disc valve: </strong> Disc valve motors ensure high
                efficiency through precise timing and are also recommended for
                smooth running at low speeds.
                <span
                  onClick={() => setShowMoreValve(false)}
                  style={{
                    cursor: "pointer",
                    color: "#ac070c",
                    textDecoration: "underline",
                    marginLeft: "4px",
                    fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                  }}
                >
                  ...less
                </span>
              </Box>
            </Box>
          )}
        </FormControl>
      </Box>

      {/* Radial Bearing Load Filter */}
      <Box sx={{ flex: "1 1 300px", minWidth: "280px" }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", mb: 1, fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif` }}
        >
          Radial bearing load
        </Typography>

        <FormControl fullWidth>
          <InputLabel
            id="radial-bearing-load-label"
            sx={{ display: "none", fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif` }}
          >
            Select bearing capacity
          </InputLabel>
          <Select
            labelId="radial-bearing-load-label"
            defaultValue=""
            onChange={(e) =>
              onFilterChange("radialBearingLoad", e.target.value)
            }
            displayEmpty
            renderValue={(selected) =>
              selected !== "" ? (
                selected
              ) : (
                <span style={{ color: "#888", fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif` }}>
                  Select bearing capacity
                </span>
              )
            }
            IconComponent={KeyboardArrowDownOutlinedIcon}
            sx={{
              borderRadius: 0,
              height: 40,
              boxShadow: "none",
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: 0,
                borderColor: "#ccc",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#ccc",
                boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.03)",
                // ⬅️ darker shadow
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#888",
              },
            }}
          >
            <MenuItem
              value=""
              sx={{
                fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                "&.Mui-selected": {
                  backgroundColor: "white !important",
                  color: "black", // optional → makes text visible
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#767676 !important",
                  color: "#fff", // optional → makes text visible
                },
                "&:hover": {
                  backgroundColor: "#767676", // a lighter hover shade
                  color: "#fff", // optional → makes text visible
                },
              }}
            >
              All
            </MenuItem>
            {bearingCapacityValues
              .slice()
              .sort((a, b) => a - b)
              .map((value, index) => (
                <MenuItem
                  key={index}
                  value={value}
                  sx={{
                    fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                    "&.Mui-selected": {
                      backgroundColor: "white !important",
                      color: "black", // optional → makes text visible
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#767676 !important",
                      color: "#fff", // optional → makes text visible
                    },
                    "&:hover": {
                      backgroundColor: "#767676", // a lighter hover shade
                      color: "#fff", // optional → makes text visible
                    },
                  }}
                >
                  {`${value} ${
                    measurementUnit === "Imperial" ? "(lbf)" : "(N)"
                  }`}
                </MenuItem>
              ))}
          </Select>

          <Typography
            variant="body2"
            sx={{
              mt: 1,
              color: "#666",
              lineHeight: 1.43,
              fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
            }}
          >
            The drop-down list displays the maximum radial bearing capacity for
            different motor series under the following conditions: <br></br>
            Journal bearings: Load measured 25 mm from the mounting flange.
            <br></br> Needle and tapered roller bearings: Load measured 50 mm
            from the mounting flange, based on a B10 bearing life of 12 million
            revolutions.
            {!showMoreBearing && (
              <span
                onClick={() => setShowMoreBearing(true)}
                style={{
                  cursor: "pointer",
                  color: "#ac070c",
                  textDecoration: "underline",
                  marginLeft: "4px",
                  fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                }}
              >
                ...more
              </span>
            )}
          </Typography>

          {showMoreBearing && (
            <Box
              mt={1}
              sx={{
                color: "#666",
                fontSize: "0.875rem",
                fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
              }}
            >
              <Box mt={1}>
                <strong>Journal bearing:</strong> Journal bearing are cost-effective
                solution for applications with moderate radial load and minimal
                axial load.
                <br></br>
              </Box>
              <Box mt={1}>
                <strong>Needle bearing:</strong> Needle bearing are compact solution
                for applications with high radial load and moderate axial load.
              </Box>
              <Box mt={1}>
                <strong>Tapered roller bearing:</strong> Tapered roller
                bearing are premium solution for applications with high radial and
                axial loads.
                <span
                  onClick={() => setShowMoreBearing(false)}
                  style={{
                    cursor: "pointer",
                    color: "#ac070c",
                    textDecoration: "underline",
                    marginLeft: "4px",
                  }}
                >
                  ...less
                </span>
              </Box>
            </Box>
          )}
        </FormControl>
      </Box>
    </Box>
  );
};

export default FilterDescription;
